import { styled } from '@mui/material';

export const StyledRecord = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;

export const StyledSentences = styled('div')`
  padding: 8px 160px;
  margin-left: auto;
  margin-right: auto;
  margin-top: -58px;
`;

export const StyledRecordTime = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: max-content;
  gap: 2px;
  height: 32px;
  gap: 8px;
  opacity: 1;
  border-radius: 480px;
  padding-top: 4px;
  padding-right: 8px;
  padding-bottom: 4px;
  padding-left: 8px;
  box-sizing: border-box;
  background-color: ${({ backgroundColor }) => backgroundColor};
`;

export const StyledRecordAgain = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

export const StyledCountTime = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;

export const StyledRecordingTime = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;
